export default {
    root: {}
}